module.exports = __webpack_public_path__ + "a79699f17e7fc81767306053c04bea79.png";